import { SelectOption } from 'govwell-ui/components/Select/types'

import { UserDataFragment, UserType } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import UserSearch from '../../Selects/UserSearch'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  customDisplay?: (user: UserDataFragment) => React.ReactNode
  getIsOptionDisabled?: (option: SelectOption<UserDataFragment>) => boolean
  includeUsersFromAllOrganizations?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  placeholder?: string
  type?: UserType
} & SelectFieldProps<UserDataFragment, TKey>
const UserSearchField = <TKey extends string>({
  customDisplay,
  field,
  getIsOptionDisabled,
  includeUsersFromAllOrganizations,
  isMultiSelect,
  isRequired,
  label,
  placeholder,
  type,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  const commonProps = {
    customDisplay,
    errorMessage,
    getIsOptionDisabled,
    includeUsersFromAllOrganizations,
    isInvalid,
    isRequired,
    label,
    onBlur: field.handleBlur,
    placeholder,
    type,
  }
  if (isMultiSelect) {
    return (
      <UserSearch
        isMultiSelect
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <UserSearch
      isMultiSelect={false}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default UserSearchField
